<template>
  <section class="grid-flex column w100">
    <div class="box flex w100 row w100">
      <div class="box-content flex w100 row custom-max-box">
      <div
        v-for="(k, index) in listRender"
        :key="index"
      >
      <div class="flex-1 flex middle column">
          <h4>{{ k }} ({{ data[k] | number }}%)</h4>
          <round-graph
            class="graph"
            :small="true"
            :loading="loading"
            :options="graphOptions"
            :chartData="getValue(k)"
          ></round-graph>
        </div>
      </div>
    </div>
    </div>
  </section>
</template>

<script>
import RoundGraph from "@/components/charts/RoundGraph";

export default {
  name: "conversion-line",
  props: ["data", "colors"],
  components: {
    RoundGraph
  },
  data() {
    return {
      loading: false,
      graphOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          labels: {
            fontColor: "black",
          },
        },
        drawTicks: true,
        cutout: 70,
      },
    };
  },
  computed: {
    listRender() {
      return Object.keys(this.data);
    },
  },
  mounted() {},
  methods: {
    getValue(key) {
      if (!this.data) {
        return 0;
      }

      var labels = []

      if (this.data[key]) {
        var auxData = [this.data[key], 100 - this.data[key]]
        labels = ['Pagos', 'Não pagos']
      }

      return {
        labels: labels,
        datasets: [
          {
            label: key,
            fill: false,
            data: auxData,
            borderWidth: 1,
          },
        ],
      };
    },
    getColor(index) {
      let auxColor = [
        "#ffc72c",
        "#c2c2c2",
        "#47265a",
        "rgb(104, 213, 136)",
        "rgb(166, 171, 176)",
      ];

      if (!this.colors) {
        return auxColor[index];
      }

      return this.colors[index]
    },
  },
};
</script>

<style lang="scss">
.label {
  margin-right: 12px;
}

.custom-max-box {
  max-height: 270px;
  padding: 16px;
}


@media only screen and (max-width: 980px) {
  .custom-max-box {
    max-height: 100%;
    height: 100%;
  }

}

</style>
